const init = () => {
  const wizard = document.querySelector('[data-js-bind="course-wizard"]');
  if (!wizard) {
    console.error('Could not initialize the wizard. No wizard found.');
    return;
  }

  const stepsWrapper = wizard.querySelector('[data-js-bind="wizard-steps"]');
  if (!stepsWrapper) {
    console.error('Could not initialize the wizard. No steps wrapper found.');
    return;
  }

  const steps = Array.from(stepsWrapper.children);
  if (!steps.length) {
    console.error('Could not initialize the wizard. No steps found.');
    return;
  }

  let tooltipTexts = [];

  try {
    tooltipTexts = JSON.parse(stepsWrapper.dataset.tooltipTexts);
  } catch (error) {
    console.warn('Error parsing tooltip texts:', error);
  }

  const stepFieldsMap = new Map();

  steps.forEach((step, index) => {
    const inputs = step.querySelectorAll('input:not([type="hidden"]), select, textarea, input[data-js-bind="datepicker"]');
    const fieldNames = Array.from(inputs).map(input => input.name).filter(name => name);
    stepFieldsMap.set(index, fieldNames);
  });

  let currentStepIndex = 0;
  let currentCityId = null;

  const updateCourseOptions = (cityName) => {
    const courseSelect = wizard.querySelector('[data-js-bind="course-select"]');
    if (!courseSelect) return;

    const optionsData = courseSelect.dataset.options;
    if (!optionsData) return;

    try {
      const allOptions = JSON.parse(optionsData);
      const cityOptions = allOptions[cityName] || [];

      courseSelect.innerHTML = '<option value="">Kies een cursus</option>';

      cityOptions.forEach(option => {
        const optionElement = document.createElement('option');
        optionElement.value = option.id;
        optionElement.textContent = option.name;
        courseSelect.appendChild(optionElement);
      });
    } catch (error) {
      console.error('Error parsing course options:', error);
    }
  };

  const updateOverviewStep = (data) => {
    const overviewStep = steps[steps.length - 1];
    if (!overviewStep || !data) return;

    const texts = overviewStep.querySelectorAll('[data-js-bind="course-information"]');

    texts.forEach(text => {
      const value = data[text.dataset.key];
      if (!value) return;

      if (text.dataset.key === 'price') {
        text.textContent = Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(Number(value));
        return;
      }

      if (text.dataset.key === 'start_date' || text.dataset.key === 'end_date') {
        text.textContent = new Date(value).toLocaleDateString('nl-NL', {
          weekday: 'short',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        return;
      }

      if (text.dataset.key === 'amount_of_weeks') {
        text.textContent = `${value} ${value === 1 ? 'week' : 'weken'}`;
        return;
      }

      text.textContent = value;
    });
  };

  const updateTooltip = () => {
    const currentStep = steps[currentStepIndex];
    let tooltip = currentStep.querySelector('[data-js-bind="tooltip"]');

    const stepKey = `step${currentStepIndex + 1}Text`;
    let text = '';

    if (currentCityId) {
      const cityTextObject = tooltipTexts.find(t => t.city_id === currentCityId);
      if (cityTextObject && cityTextObject[stepKey]) {
        text = cityTextObject[stepKey];
      }
    }

    if (!text) {
      const defaultTextObject = tooltipTexts.find(t => t.city_id === null);
      if (defaultTextObject && defaultTextObject[stepKey]) {
        text = defaultTextObject[stepKey];
      }
    }

    if (!text) {
      if (tooltip) tooltip.remove();
      return;
    }

    if (tooltip) {
      const tooltipTextElement = tooltip.querySelector('[data-js-bind="tooltip-text"]');
      if (tooltipTextElement) {
        tooltipTextElement.innerHTML = text;
      }
      return;
    }

    const template = document.getElementById('wizard-tooltip-template');
    if (template) {
      const clone = template.content.cloneNode(true);
      const tooltipTextElement = clone.querySelector('[data-js-bind="tooltip-text"]');
      if (tooltipTextElement) {
        tooltipTextElement.innerHTML = text;
      }
      currentStep.appendChild(clone);
      tooltip = currentStep.querySelector('[data-js-bind="tooltip"]');
    }
  };

  const showStep = (stepIndex) => {
    steps.forEach((step, index) => {
      step.style.display = index === stepIndex ? 'block' : 'none';
    });
    currentStepIndex = stepIndex;
    validateCurrentStep();
    updateTooltip();
  };

  const isStepValid = (stepIndex) => {
    const fieldNames = stepFieldsMap.get(stepIndex) || [];
    if (fieldNames.length === 0) {
      return true;
    }

    return fieldNames.every(fieldName => {
      const field = wizard.querySelector(`[name="${fieldName}"]`);
      if (!field) return false;

      if (field.tagName === 'SELECT') {
        return field.value && field.value !== '';
      }

      if (field.type === 'radio') {
        const radioGroup = wizard.querySelectorAll(`[name="${fieldName}"]`);
        return Array.from(radioGroup).some(radio => radio.checked);
      }

      if (field.type === 'checkbox') {
        const checkboxGroup = wizard.querySelectorAll(`[name="${fieldName}"]`);
        return Array.from(checkboxGroup).some(checkbox => checkbox.checked);
      }

      return field.value.trim() !== '';
    });
  };

  const validateCurrentStep = () => {
    const currentStep = steps[currentStepIndex];

    const nextButton = currentStep.querySelector('.btn-primary');

    if (nextButton) {
      const isValid = isStepValid(currentStepIndex);
      nextButton.disabled = !isValid;
    }
  };

  const submitFormData = async () => {
    const formData = new FormData(wizard);

    try {
      const response = await fetch('/xhr/enrollment-wizard/overview', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      return await response.json();
    } catch (error) {
      console.error('Error submitting form:', error);
      return null;
    }
  };

  const goToNextStep = async () => {
    if (currentStepIndex < steps.length - 1) {
      const currentStep = steps[currentStepIndex];
      const nextButton = currentStep.querySelector('[data-js-bind="next-step"]');
      const isSubmitStep = nextButton && nextButton.type === 'submit';

      if (isSubmitStep) {
        const originalButtonText = nextButton.innerHTML;

        nextButton.disabled = true;
        nextButton.innerHTML = 'Laden...';

        const overviewData = await submitFormData();

        nextButton.innerHTML = originalButtonText;

        if (overviewData && overviewData.success) {
          updateOverviewStep(overviewData.data);
        } else {
          console.error('Failed to load overview data');
          nextButton.disabled = false;
        }
      }

      showStep(currentStepIndex + 1);
    }
  };

  const goToPreviousStep = () => {
    if (currentStepIndex > 0) {
      showStep(currentStepIndex - 1);
    }
  };

  steps.forEach((step, stepIndex) => {
    const nextButton = step.querySelector('[data-js-bind="next-step"]');
    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (isStepValid(stepIndex)) {
          goToNextStep();
        }
      });
    }

    const backButton = step.querySelector('[data-js-bind="previous-step"]');
    if (backButton) {
      backButton.addEventListener('click', (e) => {
        e.preventDefault();
        goToPreviousStep();
      });
    }

    const fieldNames = stepFieldsMap.get(stepIndex) || [];
    fieldNames.forEach(fieldName => {
      const fields = step.querySelectorAll(`[name="${fieldName}"]`);
      fields.forEach(field => {
        field.addEventListener('change', () => {
          if (stepIndex === currentStepIndex) {
            validateCurrentStep();
          }
        });
        field.addEventListener('input', () => {
          if (stepIndex === currentStepIndex) {
            validateCurrentStep();
          }
        });
      });
    });
  });

  const citySelect = wizard.querySelector('[data-js-bind="city-select"]');
  if (citySelect) {
    if (citySelect.value) {
      const selectedOption = citySelect.options[citySelect.selectedIndex];
      const cityName = selectedOption.textContent;
      currentCityId = citySelect.value ? +citySelect.value : null;
      updateCourseOptions(cityName);
    }

    updateTooltip();

    citySelect.addEventListener('change', (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const cityName = selectedOption.textContent;
      currentCityId = citySelect.value ? +citySelect.value : null;
      updateCourseOptions(cityName);
      updateTooltip();
    });
  }

  validateCurrentStep(); // First step can be prefilled
};

init();
